module.exports = __webpack_public_path__ + "static/media/chicken-shawarma.b54c4422.jpg";